module.exports = __webpack_public_path__ + "static/img/反面定位框选.2ebf9465.gif";